import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

export interface LocationMultiSelectionDialogData {
  locations: string[];
  selectedStations: string[];
}

@Component({
  selector: 'app-location-multi-selection-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  template: `
    <h2 mat-dialog-title>Vælg lokationer</h2>
    <div mat-dialog-content>
      <mat-form-field appearance="outline" class="search-field">
        <mat-icon matPrefix>search</mat-icon>
        <input
          matInput
          [(ngModel)]="searchText"
          (input)="filterLocations()"
          placeholder="Søg efter lokationer..."
        />
      </mat-form-field>
      <div class="locations-list">
        @for (location of filteredLocations; track location) {
        <label class="location-row">
          <mat-checkbox
            [checked]="isSelected(location)"
            (change)="toggle(location, $event.checked)"
          />
          <span>{{ location }}</span>
        </label>
        }
      </div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button type="button" (click)="clearAll()">Alle</button>
      <button mat-button type="button" (click)="close()">Annuller</button>
      <button mat-flat-button color="primary" type="button" (click)="apply()">
        Anvend
      </button>
    </div>
  `,
  styles: [
    `
      .search-field {
        width: 100%;
        margin-bottom: 12px;
      }
      .locations-list {
        max-height: 360px;
        overflow: auto;
      }
      .location-row {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 4px 0;
        cursor: pointer;
      }
    `,
  ],
})
export class LocationMultiSelectionDialogComponent implements OnInit {
  searchText = '';
  filteredLocations: string[] = [];
  selected = new Set<string>();

  constructor(
    public dialogRef: MatDialogRef<LocationMultiSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LocationMultiSelectionDialogData
  ) {
    for (const s of data.selectedStations || []) {
      if (s && s !== 'all') this.selected.add(s);
    }
  }

  ngOnInit(): void {
    this.filteredLocations = [...this.data.locations];
  }

  filterLocations(): void {
    const q = this.searchText.trim().toLowerCase();
    this.filteredLocations = !q
      ? [...this.data.locations]
      : this.data.locations.filter((l) => l.toLowerCase().includes(q));
  }

  isSelected(location: string): boolean {
    return this.selected.has(location);
  }

  toggle(location: string, checked: boolean): void {
    if (checked) this.selected.add(location);
    else this.selected.delete(location);
  }

  clearAll(): void {
    this.selected.clear();
  }

  apply(): void {
    this.dialogRef.close(Array.from(this.selected));
  }

  close(): void {
    this.dialogRef.close();
  }
}
